<template>
          
  <div v-if="!isMobile()" style="background-image: url('/img/bg_pattern.png');">
    <div class="clear-filter" filter-color="black4">
      <div
        id="top"
        style="
          max-width: 1920px;          
          margin: 0 auto;
                  "
      >
        <img id="top_img" v-lazy="'/img/img_main_event.png'" width="100%"/>
      </div>
       <div id="ticket_count" @click="popup=stickerCounts[0]>0" style="margin: 0 auto;
          max-width: 1920px; 
          height: 100px;margin-top:-100px">
          <span class="total" width="100%">x{{stickerCounts[0]}}</span>
       </div>
      <div
        id="top"
        style="
          margin: 0 auto;
          max-width: 1920px; 
          height: 1350px;
        "
      >
        <div v-if="networkId!=137" style="margin:10px auto;background-image:url('/img/bg_alert.png');width:1136px;height:44px;line-height:44px;color:white;text-align:center;font-size:22px;font-weight:700;"><img src="/img/icon_alert.png">&nbsp;Wrong network. Please connect to Polygon/Matic network.</div>
        <div style="margin: 0 auto; width:760px; padding-top: 30px; height: 240px;">
            <span>
              <span v-if="stickerCounts[1]>0" class="num">{{stickerCounts[1]}}</span>
              <img v-lazy="'/img/sticker'+(stickerCounts[1] > 0?'':'_off')+'_01.png'" class="sticker"/>
            </span>
            <span style="display:inline-block;width:200px;"></span>
            <span>
              <span v-if="stickerCounts[2]>0" class="num">{{stickerCounts[2]}}</span>
              <img v-lazy="'/img/sticker'+(stickerCounts[2] > 0?'':'_off')+'_02.png'" class="sticker"/>
            </span>
        </div>
        <div style="margin: 0 auto; width: 410px; padding-top: 0px; height: 360px;">
            <span>
              <span v-if="stickerCounts[5]>0" class="num big">{{stickerCounts[5]}}</span>
              <img v-lazy="'/img/sticker'+(stickerCounts[5] > 0?'':'_off')+'_05.png'" class="sticker big"/>
            </span>
        </div>
        <div style="margin: 0 auto; width: 760px; padding-top: 0px;">
            <span>
              <span v-if="stickerCounts[3]>0" class="num">{{stickerCounts[3]}}</span>
              <img v-lazy="'/img/sticker'+(stickerCounts[3] > 0?'':'_off')+'_03.png'" class="sticker"/>
            </span>
            <span style="display:inline-block;width:200px;"></span>
            <span>
              <span v-if="stickerCounts[4]>0" class="num">{{stickerCounts[4]}}</span>
              <img v-lazy="'/img/sticker'+(stickerCounts[4] > 0?'':'_off')+'_04.png'" class="sticker"/>
            </span>
        </div>
        <div v-if="isCompleted()" @click="goCraftGoods()" style="margin: 0 auto; width: 600px; padding-top: 100px;">
          <img src="/img/btn_sticker_complete.png">
        </div>
      </div>
    </div>
    <div v-if="popup" @click="popup=false" style="position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.8);z-index:100000;text-align: center;padding-top:100px;">
      <img src="/img/sticker_complete.png" style="width:872px;height:1032px;">
    </div>
  </div>
  <div v-else>
  </div>
</template>
<script>
import { Parallax } from "@/components";
import {refreshStickers, craftGoods, getNetwork} from "../utils/wallet";
import config from '../config';

export default {
  name: "myitem",
  bodyClass: "myitem-page",
  components: {
    Parallax
  },
  created() {
    window.ethereum.on('chainChanged', (_chainId) => this.reload(_chainId));
    setTimeout(async ()=>{
      await this.reload();
    }, 1000);
  },
  
  mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
	},
  beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    handleResize(){
      let element = window.document.getElementById("ticket_count");
      let img = window.document.getElementById("top_img");
      element.style.zoom = img.clientWidth/1920;
    },
    isCompleted(){
      for(let i=1; i<6; ++i)
        if(this.stickerCounts[i]==0)
          return false;
      return true;
    },
    async reload(chainId){
      if(this.$store.state.account.wallet==null)
        return;
      try{
        console.log(chainId, await getNetwork());
        this.networkId = chainId||await getNetwork();
      await refreshStickers(this.$store);

      }catch(e){

      }
      
      let tokenIds = this.$store.state.account.wallet.stickers || [];
      this.stickerCounts = [0,0,0,0,0,0];
      for(let tokenId of tokenIds)
        this.stickerCounts[Number(tokenId)%1000]++;
    },
    async goCraftGoods(){
      let crafts = this.getCrafts();
      if(crafts.length<5)
        return;
      await craftGoods(this.$store, crafts);
    },
    getCrafts(){
      let crafts = [];
      let tokenIds = this.$store.state.account.wallet.stickers;
      for(let i=1; i<6; ++i)
      {
        let tokenId = this.getTokenId(tokenIds, i);
        if(tokenId==0)
          return [];
        crafts.push(tokenId);
      }
      return crafts;
    },
    getTokenId(tokenIds, type){
      for(let tokenId of tokenIds)
        if(Number(tokenId)%1000==type)
          return tokenId;
      return 0;
    }
  },
  data: function() {
    return {
      stickerCounts: [0,0,0,0,0,0,0],
      numDragoNFT: 0,
      networkId:config.network.polygon,
      popup:false,
    };
  }
};
</script>
<style>
.sticker{
  width:280px;
  height:280px;
}
.sticker.big{
  width:410px;
  height:410px;
}
.num{
  position:absolute;width:80px;height:80px;line-height:80px;background-image:url(/img/bg_num.png);text-align:center;font-weight:900;margin-top:180px;margin-left:180px;font-size:40px;color:white;
}
.total{
  width:80px;height:80px;line-height:80px;text-align:left;font-weight:900;margin-top:-90px;margin-left:1240px;font-size:40px;color:yellow;
}
.num.big{
  margin-top:280px;margin-left:280px;
}
#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 50vw; /* Set a default minimum width */
  margin-left: -25vw; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  top: 150px; /* 30px from the bottom */
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 150px; opacity: 1;}
}

@keyframes fadein {
  from {top: 0; opacity: 0;}
  to {top: 150px; opacity: 1;}
}

@-webkit-keyframes fadeout {
  from {top: 150px; opacity: 1;}
  to {top: 0; opacity: 0;}
}

@keyframes fadeout {
  from {top: 150px; opacity: 1;}
  to {top: 0; opacity: 0;}
}
</style>
